import { IntegrationSelectCompanyWebController } from '../controller/IntegrationSelectCompanyWebController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class IntegrationSelectCompanyWebComponent extends BaseWebComponentElement {
  public controller!: IntegrationSelectCompanyWebController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrationSelectCompanyWebController,
    });
  }
}
